
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false
  });

  isConfirm = prop<boolean>({
    type: Boolean,
    default: false
  });

  disabled = prop<boolean>({
    default: false
  });

  title = prop<string>({
    default: ""
  });

  textActive = prop<string>({
    default: ""
  });

  textInactive = prop<string>({
    default: ""
  });

  styleActive = prop<string>({
    default: ""
  });

  styleInactive = prop<string>({
    default: ""
  });

  customLabel = prop<boolean>({
    default: false,
    type: Boolean
  });

  width = prop<string>({
    default: "55px"
  });

  height = prop<string>({
    default: "30px"
  });

  knobSize = prop<string>({
    default: "26px"
  });

  knobShadow = prop<string>({
    default:
      "0 1px 3px rgba(107, 106, 106, 0.26), 0 3px 1px rgba(107, 106, 106, 0.13)"
  });
}

@Options({
  name: "Toggle"
})
export default class extends Vue.with(Props) {
  onChange() {
    if (!this.disabled) {
      this.$emit(
        "update:modelValue",
        this.isConfirm ? this.modelValue : !this.modelValue
      );
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (event.code === "Space") {
      this.onChange();
    }
  }
}
